var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-card',[_c('v-layout',{staticClass:"pb-15 pb-sm-0",attrs:{"column":""}},[_c('v-layout',{staticClass:"align-center",class:{
                'pt-3 px-4 pb-2': _vm.$slots['header']
            }},[_vm._t("header")],2),_c('v-row',{staticClass:"align-center",class:{
                'px-4': _vm.$slots['header-actions']
            },attrs:{"no-gutters":""}},[_vm._t("header-actions")],2),(_vm.$slots['header-actions'])?_c('v-divider',{staticClass:"my-4"}):_vm._e(),_vm._t("table")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }